(function () {
  'use strict';

  //
  // Wait until the theme has completed initialization before proceeding
  //
  document.addEventListener('page:loaded', function () {
    ////////////////////////////////////////////////////////////////////////
    //
    // Global objects
    //
    ////////////////////////////////////////////////////////////////////////

    //
    // Design Huddle editor object
    //
    var designHuddleEditor = null;

    //
    // Variant object
    //
    var variant = null;

    //
    // Discounts object
    //
    var discounts = [];

    //
    // Notes time debounce object
    //
    var notesDebounce;

    ////////////////////////////////////////////////////////////////////////
    //
    // Design Huddle integration functions
    //
    ////////////////////////////////////////////////////////////////////////

    //
    // Initialize Design Huddle
    //
    function initializeDesignHuddle() {
      return new Promise(function (resolve, reject) {
        try {
          //Get the customer email
          var custEmail = document.querySelector('[data-customer-email-json]');

          //Get the Design Huddle cookie
          var dhCookie = document.cookie.match('(^|;)\\s*dshd-gid-49l05id82myuq75a9kwy\\s*=\\s*([^;]+)')?.pop() || '';

          //Proceed based on whether user is logged in or not
          if (custEmail && dhCookie) {
            //User is logged in
            var url = 'https://md-api.com/getDesignHuddleUserToken?username=' + custEmail.value + '&guestCode=' + dhCookie;
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.onreadystatechange = function () {
              if (this.readyState == 4) {
                if (this.status == 200) {
                  var res = JSON.parse(this.responseText);
                  DSHDEditorLib.configure({
                    domain: 'marketdwellings.designhuddle.com',
                    access_token: res.access_token,
                  });
                  resolve();
                } else {
                  reject(this.status);
                }
              }
            };
            xhr.send();
          } else {
            //User is not logged in
            DSHDEditorLib.configure({
              domain: 'marketdwellings.designhuddle.com',
              client_id: '49l05id82myuq75a9kwy',
              guest: true,
            });
            resolve();
          }
        } catch (err) {
          reject(err);
        }
      });
    }

    //
    // Create Design Huddle Project
    //
    function createDesignHuddleProject(templateId) {
      return new Promise(function (resolve, reject) {
        try {
          DSHDEditorLib.createProject({ template_code: templateId }, function (err, data) {
            if (!err && data && data.project_id) {
              resolve(data.project_id);
            } else {
              reject(err);
            }
          });
        } catch (err) {
          reject(err);
        }
      });
    }

    //
    // Display Design Huddle Editor
    //
    function displayDesignHuddleEditor(projectId) {
      return new Promise(function (resolve, reject) {
        try {
          DSHDEditorLib.insert('customization-frame-wrapper', { project_id: projectId }, function (err, editor) {
            if (!err && editor) {
              designHuddleEditor = editor;
              resolve(editor);
            } else {
              reject(err);
            }
          });
        } catch (err) {
          reject(err);
        }
      });
    }

    //
    // Get Design Huddle mockup images for project
    //
    function getDesignHuddleMockups() {
      return new Promise(function (resolve, reject) {
        try {
          designHuddleEditor.getProjectData({}, function (err, data) {
            if (!err && data && data.pages) {
              var mockups = [];

              //Get first page render
              designHuddleEditor.getRender(
                {
                  max_width: 1000,
                  max_height: 1000,
                  render_excluded_elements: true,
                  page_id: data.pages[0].page_id,
                },
                function (err, render) {
                  if (!err && render) {
                    mockups.push(render.url);
                    if (data.pages.length > 1) {
                      //Get second page render
                      designHuddleEditor.getRender(
                        {
                          max_width: 1000,
                          max_height: 1000,
                          render_excluded_elements: true,
                          page_id: data.pages[1].page_id,
                        },
                        function (err, render) {
                          if (!err && render) {
                            mockups.push(render.url);
                            if (data.pages.length > 2) {
                              //Get third page render
                              designHuddleEditor.getRender(
                                {
                                  max_width: 1000,
                                  max_height: 1000,
                                  render_excluded_elements: true,
                                  page_id: data.pages[2].page_id,
                                },
                                function (err, render) {
                                  if (!err && render) {
                                    mockups.push(render.url);
                                    if (data.pages.length > 3) {
                                      //Get fourth page render
                                      designHuddleEditor.getRender(
                                        {
                                          max_width: 1000,
                                          max_height: 1000,
                                          render_excluded_elements: true,
                                          page_id: data.pages[3].page_id,
                                        },
                                        function (err, render) {
                                          if (!err && render) {
                                            mockups.push(render.url);
                                            resolve(mockups);
                                          } else {
                                            reject(err);
                                          }
                                        }
                                      );
                                    } else {
                                      resolve(mockups);
                                    }
                                  } else {
                                    reject(err);
                                  }
                                }
                              );
                            } else {
                              resolve(mockups);
                            }
                          } else {
                            reject(err);
                          }
                        }
                      );
                    } else {
                      resolve(mockups);
                    }
                  } else {
                    reject(err);
                  }
                }
              );
            } else {
              reject(err);
            }
          });
        } catch (err) {
          reject(err);
        }
      });
    }

    //
    // Destroy the Design Huddle Editor
    //
    function removeDesignHuddleEditor() {
      try {
        if (designHuddleEditor) {
          designHuddleEditor.remove();
        }
      } finally {
        designHuddleEditor = null;
      }
    }

    ////////////////////////////////////////////////////////////////////////
    //
    // Custom Quantity Dropdown and Price Display functions
    //
    ////////////////////////////////////////////////////////////////////////

    //
    // Get pricing for quantity including any appliable discounts
    //
    function getPricingForQuantity(unitPrice, quantity, discounts) {
      try {
        //Ensure global theme object is available
        if (window.theme == null) {
          //Missing global theme object, return empty discount pricing object
          return {
            price: '',
            compareAtPrice: '',
            discount: '',
            discountAmount: '',
            newUnitPrice: '',
          };
        }

        //Ensure unit price is valid
        if (!Number.isFinite(unitPrice)) {
          //Invalid unit price, return empty discount pricing object
          return {
            price: '',
            compareAtPrice: '',
            discount: '',
            discountAmount: '',
            newUnitPrice: '',
          };
        }

        //Find eligible discounts
        if (Array.isArray(discounts) && discounts.length > 0) {
          //Discounts exist
          var eligibleDiscounts = discounts.filter(function (discount) {
            return quantity >= discount.minQuantity;
          });

          //Check for eligible discounts
          if (eligibleDiscounts.length > 0) {
            //Eligible discounts found for quantity, sort them
            eligibleDiscounts.sort(function (a, b) {
              return b.percentDiscount - a.percentDiscount;
            });

            //return the discounted price and discount text
            return {
              price: window.theme.Currency.formatMoney(unitPrice * quantity * (1 - eligibleDiscounts[0].percentDiscount / 100)),
              compareAtPrice: window.theme.Currency.formatMoney(unitPrice * quantity),
              discount: Math.trunc(eligibleDiscounts[0].percentDiscount) + '%' + ' Off',
              discountAmount: window.theme.Currency.formatMoney(unitPrice * quantity - unitPrice * quantity * (1 - eligibleDiscounts[0].percentDiscount / 100)),
              newUnitPrice: window.theme.Currency.formatMoney(unitPrice * (1 - eligibleDiscounts[0].percentDiscount / 100)),
            };
          }
        }

        //No discount, return standard discount pricing object
        return {
          price: window.theme.Currency.formatMoney(unitPrice * quantity),
          compareAtPrice: '',
          discount: '',
          discountAmount: '',
          newUnitPrice: '',
        };
      } catch (err) {
        //Error occured, return empty discount pricing object
        return {
          price: '',
          compareAtPrice: '',
          discount: '',
          discountAmount: '',
          newUnitPrice: '',
        };
      }
    }

    //
    // Update product page pricing block
    //
    function updatePrice(variant, qty, discounts) {
      if (qty == null || qty < 1) {
        //Grab the quantity from the DOM if its missing
        if (document.querySelector("input[name='quantity']")) {
          qty = Number(document.querySelector("input[name='quantity']").value);
        }
      }

      //Ensure quantity is valid
      if (!Number.isFinite(qty)) {
        //Invalid quantity
        return;
      }

      //Get pricing
      var pricing = getPricingForQuantity(variant.price, qty, discounts);

      //Update pricing block
      var priceElement = document.querySelector('[data-product-price]');
      var compareAtElement = document.querySelector('[data-product-price-wrap]');
      var saveElement = document.querySelector('[data-save-price]');
      if (pricing.discount) {
        //Price element
        var priceSpans = priceElement.getElementsByTagName('span');
        for (var i = 0; i < priceSpans.length; i++) {
          priceSpans[i].innerHTML = pricing.price;
        }

        //Compare at element
        var compareAtSpans = compareAtElement.getElementsByTagName('span');
        for (var i = 0; i < compareAtSpans.length; i++) {
          compareAtSpans[i].innerHTML = pricing.compareAtPrice;
        }
        compareAtElement.classList.remove('hide');

        //Save element
        saveElement.innerHTML = 'Save ' + pricing.discountAmount;
        saveElement.classList.remove('hide');

        //Unit price element
        var unitpriceElement = document.querySelector('[data-unit-price]');
        unitpriceElement.innerHTML = pricing.newUnitPrice + ' per unit';
      } else {
        //Price element
        var priceSpans = priceElement.getElementsByTagName('span');
        for (var i = 0; i < priceSpans.length; i++) {
          priceSpans[i].innerHTML = pricing.price;
        }

        //Compare at element
        var compareAtSpans = compareAtElement.getElementsByTagName('span');
        for (var i = 0; i < compareAtSpans.length; i++) {
          compareAtSpans[i].innerHTML = '';
        }
        compareAtElement.classList.add('hide');

        //Save element
        saveElement.innerHTML = '';
        saveElement.classList.add('hide');

        //Unit price element
        var unitpriceElement = document.querySelector('[data-unit-price]');
        unitpriceElement.innerHTML = window.theme.Currency.formatMoney(variant.price) + ' per unit';
      }
    }

    ////////////////////////////////////////////////////////////////////////
    //
    // Customization Editor functions
    //
    ////////////////////////////////////////////////////////////////////////

    //
    // Check if browser is mobile or tablet
    //
    function isMobileOrTabletBrowser() {
      var check = false;
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }

    //
    // Show/hide customization button as needed
    //
    function updateCustomizationButton(variant) {
      try {
        var qtyRange = document.getElementById('qty__range');
        if (qtyRange && isMobileOrTabletBrowser()) {
          qtyRange.style.display = 'none';
        }
      } catch (e) {}

      var customizeButton = document.querySelector('[data-customize-item]');

      //Check if the product metadata indicates customizable
      var customizable = document.querySelector('[data-product-customizable]');
      if (customizable && variant.sku) {
        if (customizeButton.classList.contains('visually-hidden')) {
          customizeButton.classList.remove('visually-hidden');
        }
      } else {
        //Hide the customization button
        if (!customizeButton.classList.contains('visually-hidden')) {
          customizeButton.classList.add('visually-hidden');
        }
      }
    }

    ////////////////////////////////////////////////////////////////////////
    //
    // Product Page Initialization
    //
    ////////////////////////////////////////////////////////////////////////

    //
    // Initialize the product page
    //
    function initializeProductPage() {
      try {
        try {
          if (document.getElementsByClassName('flickity-page-dots') && document.getElementsByClassName('flickity-page-dots')[0]) {
            if (document.getElementsByClassName('flickity-page-dots')[0].getElementsByTagName('li').length > 15) {
              document.getElementsByClassName('flickity-page-dots')[0].style.display = 'none';
            }
          }
        } catch (ignored) {
          console.error(ignored);
        }

        var materialDropdownWrapper = document.querySelector('[data-handle="material"]');
        if (materialDropdownWrapper != null) {
          var materialDropdown = materialDropdownWrapper.children[0];
          var stakesDropdownWrapper = document.querySelector('[data-handle="include-yard-sign-stakes-2-each"]');
          if (stakesDropdownWrapper != null) {
            var stakesDropdownEl = stakesDropdownWrapper.parentNode;
            var stakesDropdown = stakesDropdownWrapper.children[0];
            if (materialDropdown.value != 'Corrugated Plastic') {
              stakesDropdownEl.style.display = 'none';
              stakesDropdown.value = 'No';
            }
            materialDropdown.addEventListener('change', function () {
              if (this.value === 'Corrugated Plastic') {
                stakesDropdownEl.style.display = 'block';
              } else {
                stakesDropdownEl.style.display = 'none';
                stakesDropdown.value = 'No';
              }
            });
          }
        }
      } catch (e) {}

      //Try to get the current variant from the DOM, since it was not provided as an argument
      var variantEl = document.querySelector('[data-current-variant-json]');
      if (variantEl) {
        variant = JSON.parse(variantEl.innerHTML);
      } else {
        var productEl = document.querySelector('[data-variant-json]');
        if (productEl) {
          variant = JSON.parse(productEl.innerHTML)[0];
        }
      }

      if (variant) {
        //Apply any applicable discounts
        var discountCollEl = document.querySelector('[data-discount-id-json]');
        var discountEl = document.querySelector('[data-discount-json]');
        if (discountEl && discountEl.innerHTML && discountEl.innerHTML.trim()) {
          var discountDefs = JSON.parse(discountEl.innerHTML);
          if (discountDefs && discountCollEl && discountCollEl.innerHTML && discountCollEl.innerHTML.trim()) {
            if (document.querySelector('input[name="properties[Discounts]"]')) {
              document.querySelector('input[name="properties[Discounts]"]').remove();
            }
            var addToCartBtn = document.querySelector('[data-add-to-cart]');
            var discountProp = document.createElement('input');
            discountProp.setAttribute('type', 'hidden');
            discountProp.setAttribute('name', 'properties[_discountCollection]');
            discountProp.value = discountCollEl.innerHTML.trim();
            addToCartBtn.parentNode.appendChild(discountProp);

            discounts = discountDefs;
          }
        }

        //Update the price
        updatePrice(variant, null, discounts);

        //Show/Hide the customize button
        updateCustomizationButton(variant);

        //handle slider change
        var qtySlider = document.getElementById('qty__range');
        qtySlider.removeEventListener('input', onQtySliderChange);
        qtySlider.addEventListener('input', onQtySliderChange);
      }
    }

    //
    // Handle quantity slider change
    //
    function onQtySliderChange(e) {
      var qtyInput = document.getElementsByName('quantity')[0];
      qtyInput.value = e.target.value;
      qtyInput.dispatchEvent(new Event('change'));
    }

    //
    // Initialize the cart page
    //
    function initializeCartPage(cartUpdate) {
      var cartItems = null;
      if (cartUpdate) {
        cartItems = cartUpdate.items;
      } else if (document.querySelector('[data-cart-json]')) {
        cartItems = JSON.parse(document.querySelector('[data-cart-json]').innerHTML);
      }

      if (cartItems) {
        //Build request body
        var rqBody = {
          notes: document.getElementById('CartNote') ? document.getElementById('CartNote').value : '',
          cartItems: [],
        };

        for (var i = 0; i < cartItems.length; i++) {
          var itemProps = [];
          if (cartItems[i].properties) {
            for (const [key, value] of Object.entries(cartItems[i].properties)) {
              itemProps.push({ name: key, value: value });
            }
          }
          rqBody.cartItems.push({
            lineItemId: cartItems[i].key,
            variantId: cartItems[i].variant_id,
            collectionId: cartItems[i].properties ? parseInt(cartItems[i].properties._discountCollection) : null,
            quantity: cartItems[i].quantity,
            properties: itemProps,
          });
        }

        //Create draft order if applicable and get discounts
        var savedDraftId = sessionStorage.getItem('draftOrderId');
        if (savedDraftId) {
          var url = 'https://md-api.com/cartDiscounts2?draftOrderId=' + savedDraftId;
        } else {
          var url = 'https://md-api.com/cartDiscounts2';
        }

        var xhr = new XMLHttpRequest();
        xhr.open('POST', url, true);
        xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        xhr.onreadystatechange = function () {
          if (this.readyState == 4) {
            if (this.status == 200) {
              if (this.responseText) {
                var res = JSON.parse(this.responseText);
                if (res && res.draftOrderLink) {
                  var checkoutForm = document.getElementById('CartPageForm');
                  var checkoutButton = checkoutForm.querySelector('button[type="submit"]');
                  checkoutButton.onclick = function (e) {
                    e.preventDefault();
                    window.location.href = res.draftOrderLink;
                  };

                  //Handle notes
                  var notesInput = document.getElementById('CartNote');
                  notesInput.removeEventListener('keyup', handleNotesChange);
                  notesInput.removeEventListener('change', handleNotesChange);
                  notesInput.addEventListener('keyup', handleNotesChange);
                  notesInput.addEventListener('change', handleNotesChange);

                  //Store draftOrderId
                  if (res.draftOrderId) {
                    sessionStorage.setItem('draftOrderId', res.draftOrderId);
                  }

                  //Update pricing
                  try {
                    //Get the html cart item elements
                    var cartItemEls = document.getElementsByClassName('cart__item');

                    //Proceed if the elements are found and discounts are present in the response
                    if (cartItemEls && res.cartItemDiscounts) {
                      for (var i = 0; i < cartItemEls.length; i++) {
                        for (var t = 0; t < res.cartItemDiscounts.length; t++) {
                          //Line item data
                          var lineItemKey = cartItemEls[i].getAttribute('data-key');
                          var lineItemQty = document.getElementById('cart_updates_' + res.cartItemDiscounts[t].lineItemId).value;

                          //Discount response data
                          var discountKey = res.cartItemDiscounts[t].lineItemId;
                          var discountQty = res.cartItemDiscounts[t].quantity;

                          //Check for key match
                          if (lineItemKey == discountKey) {
                            //Check for quantity match
                            if (lineItemQty == discountQty) {
                              //Check to ensure discount is present
                              if (res.cartItemDiscounts[t].percentDiscount) {
                                //Discount available for this line item, update pricing elements
                                updateRegularPriceDisplay(cartItemEls[i], true);
                                updateDiscountPriceDisplay(cartItemEls[i], res.cartItemDiscounts[t]);
                                updateDiscountDescriptionDisplay(cartItemEls[i], res.cartItemDiscounts[t]);
                                setDiscountedCartSubtotal(res.draftOrderSubtotal);
                              }
                            }
                          }
                        }
                      }
                    }
                  } catch (e) {
                    console.error(e);
                  }
                } else {
                  //Handle notes
                  var notesInput = document.getElementById('CartNote');
                  notesInput.removeEventListener('keyup', handleNotesChange);
                  notesInput.removeEventListener('change', handleNotesChange);
                  removeDiscountPricing();
                }
              } else {
                //Handle notes
                var notesInput = document.getElementById('CartNote');
                notesInput.removeEventListener('keyup', handleNotesChange);
                notesInput.removeEventListener('change', handleNotesChange);
                removeDiscountPricing();
              }
            } else {
              //Handle notes
              var notesInput = document.getElementById('CartNote');
              notesInput.removeEventListener('keyup', handleNotesChange);
              notesInput.removeEventListener('change', handleNotesChange);
              removeDiscountPricing();
            }
          }
        };
        xhr.send(JSON.stringify(rqBody));
      }
    }

    //
    // Display cart item regular price based on discount
    //
    function updateRegularPriceDisplay(cartItemEl, discountPresent) {
      if (cartItemEl) {
        var regularPrice = cartItemEl.querySelector('[data-reg-price]');
        var strikeRegPrice = cartItemEl.querySelector('[data-reg-price-discount]');
        if (regularPrice && strikeRegPrice) {
          if (discountPresent) {
            if (!regularPrice.classList.contains('visually-hidden')) {
              regularPrice.classList.add('visually-hidden');
            }
            if (strikeRegPrice.classList.contains('visually-hidden')) {
              strikeRegPrice.classList.remove('visually-hidden');
            }
          } else {
            if (regularPrice.classList.contains('visually-hidden')) {
              regularPrice.classList.remove('visually-hidden');
            }
            if (!strikeRegPrice.classList.contains('visually-hidden')) {
              strikeRegPrice.classList.add('visually-hidden');
            }
          }
        }
      }
    }

    //
    // Display cart item discount price based on discount
    //
    function updateDiscountPriceDisplay(cartItemEl, discountData) {
      if (cartItemEl) {
        var discountPrice = cartItemEl.querySelector('[data-new-price-discount]');
        if (discountPrice) {
          if (discountData) {
            var unitPrice = Number(discountPrice.getElementsByTagName('span')[1].textContent.replace('$', '').replace(',', ''));
            var quantity = discountData.quantity;
            var percent = discountData.percentDiscount;
            console.log(`Unit Price: ${unitPrice}`);
            console.log(`Quantity: ${quantity}`);
            console.log(`Percent: ${percent}`);
            discountPrice.getElementsByTagName('span')[0].textContent = window.theme.Currency.formatMoney(unitPrice * quantity * (100 - percent));
            if (discountPrice.classList.contains('visually-hidden')) {
              discountPrice.classList.remove('visually-hidden');
            }
          } else {
            if (!discountPrice.classList.contains('visually-hidden')) {
              discountPrice.classList.add('visually-hidden');
              console.log(`hidden`);
            }
          }
        }
      }
    }

    //
    // Display cart item discount description based on discount
    //
    function updateDiscountDescriptionDisplay(cartItemEl, discountData) {
      if (cartItemEl) {
        var discDescription = cartItemEl.querySelector('[data-discount]');
        var discountPrice = cartItemEl.querySelector('[data-new-price-discount]');
        if (discDescription && discountPrice) {
          if (discountData) {
            var unitPrice = Number(discountPrice.getElementsByTagName('span')[1].textContent.replace('$', '').replace(',', ''));
            var quantity = discountData.quantity;
            var percent = discountData.percentDiscount;
            discDescription.textContent = percent + '% Off (-' + window.theme.Currency.formatMoney(unitPrice * quantity * percent) + ')';
            if (discDescription.classList.contains('visually-hidden')) {
              discDescription.classList.remove('visually-hidden');
            }
          } else {
            if (!discDescription.classList.contains('visually-hidden')) {
              discDescription.classList.add('visually-hidden');
            }
          }
        }
      }
    }

    //
    // Set the discounted cart subtotal
    //
    function setDiscountedCartSubtotal(draftOrderSubtotal) {
      //Set the cart total
      var cartSubtotal = document.querySelectorAll('[data-subtotal]');
      if (cartSubtotal) {
        for (var i = 0; i < cartSubtotal.length; i++) {
          cartSubtotal[i].innerHTML = draftOrderSubtotal;
        }
      }
    }

    //
    // Remove discount pricing
    //
    function removeDiscountPricing() {
      //Update pricing
      try {
        //Remove draft order checkout redirect
        var checkoutForm = document.getElementById('CartPageForm');
        var checkoutButton = checkoutForm.querySelector('button[type="submit"]');
        checkoutButton.onclick = null;

        //Remove discounted price displays
        var cartItemEls = document.getElementsByClassName('cart__item');
        if (cartItemEls) {
          for (var i = 0; i < cartItemEls.length; i++) {
            updateRegularPriceDisplay(cartItemEls[i], false);
            updateDiscountPriceDisplay(cartItemEls[i], null);
            updateDiscountDescriptionDisplay(cartItemEls[i], null);
          }
        }
      } catch (e) {
        console.error(e);
      }
    }

    //
    // Handle notes change
    //
    function handleNotesChange(e) {
      clearTimeout(notesDebounce);
      notesDebounce = setTimeout(updateDraft, 2000);
    }

    //
    // Update draft
    //
    function updateDraft() {
      //Update draft order notes
      var notesInput = document.getElementById('CartNote');
      var savedDraftId = sessionStorage.getItem('draftOrderId');
      var url = 'https://md-api.com/cartDiscountNotes?draftOrderId=' + savedDraftId + '&notes=' + notesInput.value;
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.send();
    }

    //
    // Initialize the product page
    //
    function initializeCustomizePage() {
      if (window.location.href.indexOf('pages/customize-item') > -1) {
        var loading = document.querySelector('[md-cust-modal-loading]');
        var editorPage = document.querySelector('[md-cust-modal-editor-page]');
        var error = document.querySelector('[md-cust-modal-error]');
        var urlParams = new URLSearchParams(window.location.search);
        var projectId = urlParams.get('projectId');
        if (!projectId) {
          //Ensure the loading element is hidden
          loading.style.display = 'none';

          //Show the error element
          error.style.display = 'flex';

          return;
        }

        //Initialize Design Huddle editor
        initializeDesignHuddle()
          .then(function () {
            displayDesignHuddleEditor(projectId)
              .then(function (designHuddleEditor) {
                var designHuddleEditor = designHuddleEditor;
                setTimeout(function () {
                  //Ensure the loading element is hidden
                  loading.style.display = 'none';

                  //Show the editor page
                  editorPage.style.display = 'flex';

                  //Highlight editable items
                  try {
                    if (designHuddleEditor) {
                      designHuddleEditor.getProjectData({}, function (err, data) {
                        var elements = Object.values(data.pages[0].elements);
                        var textElements = elements.filter(function (element) {
                          return element.type === 'text';
                        });
                        var elementIDs = textElements.map(function (textElement) {
                          return textElement.element_id;
                        });
                        designHuddleEditor.highlightElements(elementIDs, {
                          duration: 3500,
                        });
                      });
                    }
                  } catch {}
                }, 2000);
              })
              .catch(function () {
                //Ensure the loading element is hidden
                loading.style.display = 'none';

                //Show the error element
                error.style.display = 'flex';
              });
          })
          .catch(function () {
            //Ensure the loading element is hidden
            loading.style.display = 'none';

            //Show the error element
            error.style.display = 'flex';
          });
      }
    }

    //
    // Paper Color Hex Mapping
    //
    function getHexForColorValue(value) {
      if (value === undefined || value === null) {
        return '#f7f6fc';
      }

      switch (value.toLowerCase().trim()) {
        case 'white':
          return '#f7f6fc';
        case 'gray':
          return '#e0ded5';
        case 'cream':
          return '#f9f1e4';
        case 'kraft':
          return '#c8a788';
        case 'lemon':
          return '#fce300';
        case 'bright carrot':
          return '#ffba10';
        case 'carrot':
          return '#FF7E30';
        case 'scarlet':
          return '#d01914';
        case 'razzle berry':
          return '#d53e85';
        case 'grapesicle':
          return '#CBBDD9';
        case 'arctic':
          return '#5ac6ec';
        case 'light green':
          return '#d3ea36';
        case 'green apple':
          return '#83DC1F';
        case 'pink':
          return '#E4B9AC';
        case 'terra cotta':
          return '#B16F66';
        case 'champagne':
          return '#EACF95';
        case 'seafoam':
          return '#B5D4CC';
        case 'periwinkle':
          return '#CACEDD';
        case 'sky blue':
          return '#D6E4EB';
        case 'pastel green':
          return '#A8E7D4';
        case 'pastel blue':
          return '#86CEE4';
        case 'pastel purple':
          return '#B79AD1';
        case 'pastel pink':
          return '#EBACB6';
        case 'darkhands':
          return '#8E6042';
        case 'lighthands':
          return '#E1BCA8';
        case 'tangerine':
          return '#D6A46D';
        case 'olive':
          return '#999F5B';
        case 'lilac':
          return '#9F83A7';
        case 'peach':
          return '#EEC8BB';
        case 'ocean':
          return '#D1E2F6';
        case 'sunrise':
          return '#E8AC52';
        case 'blush':
          return '#DEB9AA';
        case 'sky':
          return '#99C3C8';
        case 'oldrose':
          return '#C2A595';
        case 'black':
          return '#000';
        case 'green':
          return '#5F983D';
        case 'sand':
          return '#BAAF88';
        case 'blue':
          return '#142767';
        case 'eggplant':
          return '#4C2949';
        case 'red':
          return '#773231';
        case 'beige':
          return '#E8E5DE';
        case 'presents':
          return '#B8DDD6';
        case 'santa':
          return '#EDD9CC';
        case 'tree':
          return '#2A616F';
        case 'butterscotch':
          return '#EECC7B';
        case 'waves':
          return '#476074';
        case 'mauve':
          return '#CBC1BD';
        case 'plum':
          return '#7D223D';
        case 'sage':
          return '#A4B2A6';
        case 'light pink':
          return '#e39ba0';
        case 'light purple':
          return '#bdb0cc';
        case 'light blue':
          return '#b2cfd1';
        case 'moonstone blue':
          return '#819ECD';
        case 'old rose':
          return '#D5B8B1';
        case 'bright sun':
          return '#F8D941';
        case 'light olive':
          return '#B9C26C';
        case 'cornflower blue':
          return '#9DD4E5';
        case 'sunrise orange':
          return '#F4764A';
        case 'soft pink':
          return '#F9B5B5';
        case 'tomato red':
          return '#f26c50';
        case 'regal red':
          return '#ce011e';
        case 'dark gray':
          return '#252526';
        case 'orange':
          return '#ff8300';
        case 'bright blue':
          return '#4a9cbf';
        case 'cobalt':
          return '#144b8d';
        case 'cherry':
          return '#ddb08c';
        case 'maple':
          return '#e7cfb8';
        default:
          return '#f7f6fc';
      }
    }

    //
    // Handle variant quantity change
    //
    document.addEventListener('variant:quantityChange', function (e) {
      if (e.detail && e.detail.quantity) {
        //Update the price with the new quantity
        updatePrice(variant, Number(e.detail.quantity), discounts);

        var qtySlider = document.getElementById('qty__range');
        qtySlider.value = Number(e.detail.quantity);
      }
    });

    //
    // Handle variant change
    //
    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant) {
        //Update the variant object
        variant = e.detail.variant;

        //Update the price
        updatePrice(variant, null, discounts);

        //Show/Hide the customize button
        updateCustomizationButton(variant);

        //Clone the color selector, if applicable
        try {
          var custSec = document.querySelector('[md-customization-sec]');
          var colorPicker = document.querySelector('fieldset[data-handle=color]');
          var colorWrapper = document.getElementById('customization-color-wrapper');
          if (colorPicker && colorWrapper && custSec.style.display == 'block') {
            var clone = colorPicker.closest('div').cloneNode(true);
            colorWrapper.textContent = '';
            colorWrapper.style.display = 'block';
            colorWrapper.appendChild(clone);
          }
        } finally {
        }

        //Push a color change to the editor, if applicable
        try {
          if (designHuddleEditor) {
            var colorEl = document.querySelector('[data-variant-color-label]');
            if (colorEl) {
              try {
                if (colorEl.innerText) {
                  if (colorEl.innerText == 'KRAFT' || colorEl.innerText == 'LEMON' || colorEl.innerText == 'CARROT' || colorEl.innerText == 'SCARLET' || colorEl.innerText == 'LIGHT PINK' || colorEl.innerText == 'LIGHT PURPLE' || colorEl.innerText == 'RAZZLE BERRY' || colorEl.innerText == 'GREEN APPLE') {
                    document.getElementById('disclaimer_paper_color').innerText = colorEl.innerText;
                    document.getElementById('customization-color-disclaimer').style.display = 'block';
                  } else {
                    document.getElementById('customization-color-disclaimer').style.display = 'none';
                  }
                }
              } catch (e) {}
              var colorSelection = getHexForColorValue(colorEl.innerText);
              designHuddleEditor.changeElements({
                elements: {
                  custom_background_color_front: {
                    color: colorSelection,
                  },
                  custom_background_color_back: {
                    color: colorSelection,
                  },
                },
              });
            }
          }
        } catch {}
      }
    });

    //
    // Handle variant loaded (modal product page)
    //
    document.addEventListener('variant:loaded', function (e) {
      if (e.detail && e.detail.variant) {
        //Update the variant object
        variant = e.detail.variant;

        //Initialize the product page
        initializeProductPage();
      }
    });

    //
    // Handle cart updated (cart page)
    //
    document.addEventListener('cart:updated', function (e) {
      if (e.detail && e.detail.cart) {
        //Initialize the cart page
        initializeCartPage(e.detail.cart);
      }
    });

    //Initialize the product page if applicable
    initializeProductPage();

    //Initialize the cart page if applicable
    initializeCartPage(null);

    //Initialize the customize page if applicable
    initializeCustomizePage();
  });
})();
